/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconWashDryW = createReactComponent("outline", "wash-dry-w", "IconWashDryW", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8", "key": "svg-1" }]]);

export { IconWashDryW as default };
//# sourceMappingURL=IconWashDryW.mjs.map
